import { getColorByAliasGenerator } from '../index.mjs';
import { hex2RGBA } from './hexToRgba.mjs';
import { ThemeColorScaleTypes } from '../../enums/index.mjs';

function getFogColorSetGenerator(colorSet, scale, mainColor) {
  return function () {
    var rgbaColorSet = {
      fog10: hex2RGBA(colorSet.fog10),
      grey50: hex2RGBA(colorSet.grey50),
      grey100: hex2RGBA(colorSet.grey100),
      grey200: hex2RGBA(colorSet.grey200),
      grey300: hex2RGBA(colorSet.grey300),
      grey400: hex2RGBA(colorSet.grey400),
      grey500: hex2RGBA(colorSet.grey500),
      grey600: hex2RGBA(colorSet.grey600),
      grey700: hex2RGBA(colorSet.grey700),
      grey800: hex2RGBA(colorSet.grey800),
      grey900: hex2RGBA(colorSet.grey900),
      grey1000: hex2RGBA(colorSet.grey1000),
      white10: hex2RGBA(colorSet.white10),
      white50: hex2RGBA(colorSet.white50),
      white100: hex2RGBA(colorSet.white100),
      white200: hex2RGBA(colorSet.white200),
      white300: hex2RGBA(colorSet.white300),
      white400: hex2RGBA(colorSet.white400),
      white500: hex2RGBA(colorSet.white500),
      white600: hex2RGBA(colorSet.white600),
      white700: hex2RGBA(colorSet.white700),
      white800: hex2RGBA(colorSet.white800),
      white900: hex2RGBA(colorSet.white900),
      white1000: hex2RGBA(colorSet.white1000)
    };
    switch (scale) {
      case ThemeColorScaleTypes.BLACK:
        {
          return Object.assign(Object.assign(Object.assign({}, colorSet), rgbaColorSet), {
            color: mainColor,
            fog10: hex2RGBA(colorSet.grey10),
            fog50: hex2RGBA(colorSet.grey50),
            fog100: hex2RGBA(colorSet.grey100),
            fog200: hex2RGBA(colorSet.grey200),
            fog300: hex2RGBA(colorSet.grey300),
            fog400: hex2RGBA(colorSet.grey400),
            fog500: hex2RGBA(colorSet.grey500),
            fog600: hex2RGBA(colorSet.grey600),
            fog700: hex2RGBA(colorSet.grey700),
            fog800: hex2RGBA(colorSet.grey800),
            fog900: hex2RGBA(colorSet.grey900)
          });
        }
      case ThemeColorScaleTypes.WHITE:
        {
          return Object.assign(Object.assign(Object.assign({}, colorSet), rgbaColorSet), {
            color: mainColor,
            fog10: hex2RGBA(colorSet.white10),
            fog50: hex2RGBA(colorSet.white50),
            fog100: hex2RGBA(colorSet.white100),
            fog200: hex2RGBA(colorSet.white200),
            fog300: hex2RGBA(colorSet.white300),
            fog400: hex2RGBA(colorSet.white400),
            fog500: hex2RGBA(colorSet.white500),
            fog600: hex2RGBA(colorSet.white600),
            fog700: hex2RGBA(colorSet.white700),
            fog800: hex2RGBA(colorSet.white800),
            fog900: hex2RGBA(colorSet.white900)
          });
        }
      default:
        return Object.assign(Object.assign({}, colorSet), {
          color: mainColor
        });
    }
  };
}
function elementTheme2ColorSet(palette, elementThemeValue) {
  var getColorByAlias = getColorByAliasGenerator(palette);
  var mainColor = getColorByAlias(elementThemeValue.color);
  var getFogColorSet = getFogColorSetGenerator(palette.colorSetV2, elementThemeValue.scale, mainColor);
  return getFogColorSet();
}

export { elementTheme2ColorSet as default, getFogColorSetGenerator };
